module.exports = __webpack_public_path__ + "media/images/brandsInstagramPage-167a1bf9.png";